import { ComponentPropsWithoutRef, FC } from 'react';

type SaveIconProps = ComponentPropsWithoutRef<'svg'>;

export const SaveIcon: FC<SaveIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14.5 4.61888V12.7702C14.5 13.1112 14.3803 13.4014 14.1408 13.6408C13.9014 13.8803 13.6114 14 13.2705 14H3.72947C3.38865 14 3.09856 13.8803 2.85921 13.6408C2.61974 13.4014 2.5 13.1114 2.5 12.7705V3.22947C2.5 2.88865 2.61974 2.59856 2.85921 2.35921C3.09856 2.11974 3.38877 2 3.72983 2H11.8811L14.5 4.61888ZM13.4909 5.03435L11.4656 3.00911H3.73109C3.66629 3.00911 3.61309 3.0299 3.5715 3.0715C3.5299 3.11309 3.50911 3.16629 3.50911 3.23109V12.7689C3.50911 12.8337 3.5299 12.8869 3.5715 12.9285C3.61309 12.9701 3.66629 12.9909 3.73109 12.9909H13.2689C13.3337 12.9909 13.3869 12.9701 13.4285 12.9285C13.4701 12.8869 13.4909 12.8337 13.4909 12.7689V5.03435ZM8.5 11.6987C8.9751 11.6987 9.37987 11.5315 9.71432 11.1972C10.0486 10.8627 10.2158 10.458 10.2158 9.98287C10.2158 9.50777 10.0486 9.10306 9.71432 8.76873C9.37987 8.43429 8.9751 8.26706 8.5 8.26706C8.0249 8.26706 7.62013 8.43429 7.28568 8.76873C6.95136 9.10306 6.78419 9.50777 6.78419 9.98287C6.78419 10.458 6.95136 10.8627 7.28568 11.1972C7.62013 11.5315 8.0249 11.6987 8.5 11.6987ZM4.52236 6.45965H10.3143V4.02236H4.52236V6.45965ZM3.50911 5.03435V12.9909V3.00911V5.03435Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
